import {useCallback, useEffect, useState} from 'react'

import {
  getTheme,
  themeModelSKey,
} from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

export type ChatbotResolvedTheme = 'light' | 'dark'

export function useChatbotResolvedTheme(): ChatbotResolvedTheme {
  const readTheme = useCallback((): ChatbotResolvedTheme => {
    return getTheme() === 'dark' ? 'dark' : 'light'
  }, [])

  const [resolvedTheme, setResolvedTheme] = useState<ChatbotResolvedTheme>(readTheme)

  useEffect(() => {
    const sync = () => setResolvedTheme(readTheme())

    sync()

    const observer = new MutationObserver(sync)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme'],
    })

    const onStorage = (event: StorageEvent) => {
      if (event.key === themeModelSKey) {
        sync()
      }
    }
    window.addEventListener('storage', onStorage)

    return () => {
      observer.disconnect()
      window.removeEventListener('storage', onStorage)
    }
  }, [readTheme])

  return resolvedTheme
}
